var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamic_Info Page-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #4bccea } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2 Finger drag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1027.5 646.5v128.8c0 40.3-7 109.3-20.4 163.2-30.6 123.3-99.3 173.6-237.2 173.6-228.1 0-300.7-210.1-328-289.2-2.9-8.4-5.3-15.3-7.4-20.5-38.2-95.7-76.9-154.3-77.3-154.8-2.2-3.3-3.3-7.1-3.3-11 0-34 41.8-59.5 79.2-59.5 44.2 0 77.1 24.9 99.7 51.1l-0.6-249.1c0-43.8 35.5-79.3 79.2-79.3 16.5 0 31.7 5 44.4 13.6 10.8-30.9 40-53.2 74.5-53.2 43.7 0 79.2 35.5 79.2 79.2v209.1c11.7-6.8 25.2-11 39.7-11 33.2 0 61.7 20.7 73.4 49.8 10.4-6.3 22.5-10.2 35.5-10.2 38.3 0 69.4 31.2 69.4 69.4zm-39.7 0c0-16.4-13.3-29.7-29.7-29.7-16.4 0-29.7 13.3-29.7 29.7v49.5c0 10.9-8.8 19.8-19.8 19.8-10.9 0-19.8-8.9-19.8-19.8v-79.2c0-21.9-17.8-39.7-39.6-39.7-21.9 0-39.7 17.8-39.7 39.7v59.4c0 10.9-8.8 19.8-19.8 19.8-10.9 0-19.8-8.9-19.8-19.8v-336.8c0-21.8-17.8-39.6-39.6-39.6-21.8 0-39.6 17.8-39.6 39.6l0.6 257.5c0 1.1-0.5 2-0.6 3.1v36.6c0 10.9-8.9 19.8-19.8 19.8-11 0-19.8-8.9-19.8-19.8v-257.6c0-21.8-17.8-39.6-39.7-39.6-21.8 0-39.6 17.8-39.6 39.6l0.9 356.6c0 2.9-0.8 28.8-25.6 53.7-3.9 3.8-9 5.8-14 5.8-5.1 0-10.1-2-14-5.8-7.8-7.7-7.8-20.3-0.1-28 13.2-13.3 14-25.6 14-26.1v-33.3c-5-11.3-39.8-85.1-99.9-85.1-19 0-33.5 10.1-38.1 16.4 12 19.2 44 73.8 76.3 154.5 2.3 5.6 4.9 13.2 8 22.3 27.2 78.5 90.7 262.4 290.6 262.4 118.9 0 172.8-38.9 198.7-143.4 12.7-50.9 19.2-115.8 19.2-153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m710.5 180.9c0-10.9-8.9-19.8-19.8-19.8h-356.6c-11 0-19.8 8.9-19.8 19.8 0 11 8.8 19.8 19.8 19.8h356.6c10.9 0 19.8-8.8 19.8-19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m571.8 260.2c0-11-8.9-19.9-19.8-19.9h-178.3c-11 0-19.8 8.9-19.8 19.9 0 10.9 8.8 19.8 19.8 19.8h178.3c10.9 0 19.8-8.9 19.8-19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m413.3 319.6c-10.9 0-19.8 8.9-19.8 19.8 0 10.9 8.9 19.8 19.8 19.8h59.5c10.9 0 19.8-8.9 19.8-19.8 0-10.9-8.9-19.8-19.8-19.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePan);
export default __webpack_public_path__ + "static/media/mobile-pan.f4a042da4f1d7afeab4f7ed4a71772fd.svg";
export { ForwardRef as ReactComponent };